import { AfterViewInit, Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
	selector: 'bb-wysiwyg',
	templateUrl: './bb-wysiwyg.component.html',
	styleUrls: ['./bb-wysiwyg.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbWysiwygComponent),
		multi: true
	}],
})

export class BbWysiwygComponent implements ControlValueAccessor, OnInit, AfterViewInit {
	@Input() editChange: ChangeEvent;
	@ViewChild('editor') editorElement: any;

	editor = ClassicEditor;
	wysiwygValue: string;

	constructor() {
		this.wysiwygValue = '';
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	writeValue(value: any) {
		this.wysiwygValue = value || '';
	}

	registerOnTouched() {
	}

	ngOnInit() {
	}

	ngAfterViewInit() {
	}

	propagateChange = (_: any) => { };

	onCkEditorChange() {
		this.propagateChange(this.wysiwygValue);
	}
}
